import type { MediaLayer } from './types';

export function addLayer(layers: MediaLayer[], layer: MediaLayer): MediaLayer[] {
  return [...layers, layer];
}

export function updateLayer(
  layers: MediaLayer[],
  id: string,
  patch: Partial<MediaLayer>,
): MediaLayer[] {
  return layers.map((l) => (l.id === id ? ({ ...l, ...patch } as MediaLayer) : l));
}

export function removeLayer(layers: MediaLayer[], id: string): MediaLayer[] {
  return layers.filter((l) => l.id !== id);
}

/** Move a layer to `toIndex` (its FINAL position), restacking the render along
 *  with it — array order is z-order. Returns the input array unchanged when the
 *  layer is missing or already there, so a pointermove that stays on the
 *  current lane neither re-renders nor re-persists. */
export function moveLayer(layers: MediaLayer[], id: string, toIndex: number): MediaLayer[] {
  const from = layers.findIndex((l) => l.id === id);
  if (from === -1) return layers;
  const to = Math.min(layers.length - 1, Math.max(0, toIndex));
  if (to === from) return layers;
  const next = [...layers];
  const [moved] = next.splice(from, 1);
  next.splice(to, 0, moved);
  return next;
}
